import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"5px"} }
const _hoisted_2 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_icon, { icon: _ctx.icon }, null, 8, ["icon"]),
    _createTextVNode(" " + _toDisplayString(_ctx.title) + " ", 1),
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event)),
      class: "ddl"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionData, (option) => {
        return (_openBlock(), _createElementBlock("option", {
          key: `${option.id ? option.id : option}`,
          value: option
        }, _toDisplayString(option.name ? option.name : option), 9, _hoisted_2))
      }), 128))
    ], 512), [
      [_vModelSelect, _ctx.selected]
    ])
  ]))
}